import React from 'react';

const CompanyStatement = () => {
  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              Safeguarding Processes.<br />
              Enhancing Reliability.<br />
              Ensuring Compliance.
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Experts in functional safety for process industries: refineries, chemicals, GTL.
            </p>
          </div>
          <div className="relative">
            <img
              src="/assets/asset-12.jpg"
              alt="Industrial technical shapes"
              className="rounded-lg shadow-xl"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-transparent rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStatement;
